import { render, staticRenderFns } from "./NotificationRules.vue?vue&type=template&id=67e2e06e&scoped=true&"
import script from "./NotificationRules.vue?vue&type=script&lang=js&"
export * from "./NotificationRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e2e06e",
  null
  
)

export default component.exports